import { render, staticRenderFns } from "./ContactRequestTile.vue?vue&type=template&id=0bcda688&scoped=true&lang=pug&"
import script from "./ContactRequestTile.vue?vue&type=script&lang=js&"
export * from "./ContactRequestTile.vue?vue&type=script&lang=js&"
import style0 from "./ContactRequestTile.vue?vue&type=style&index=0&id=0bcda688&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcda688",
  null
  
)

export default component.exports